(function($) {
  'use strict';

  // Import Preview Table Component
  // Unified component for both CSV and IMDB import previews
  const ImportPreviewTable = {

    // Render a preview table with the given data
    render: function(config) {
      const {
        data = [],
        type = 'csv', // 'csv' or 'imdb'
        container,
        onSelectionChange,
        existingData = [],
        canEditContact = false,
        reverseRoleMap = {},
      } = config;

      // Create table HTML
      let tableHtml = `
        <table class="import-preview-table">
          <thead>
            <tr>
              <th width="40"><input type="checkbox" id="select-all-${type}" checked></th>
              <th width="50">Avatar</th>
              <th>Name</th>
              <th>Character</th>
              <th>Roles</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
      `;

      data.forEach((person, index) => {
        const row = this.renderRow({
          person,
          index,
          type,
          existingData,
          canEditContact,
          reverseRoleMap,
        });
        tableHtml += row;
      });

      tableHtml += '</tbody></table>';

      // Render to container
      $(container).html(tableHtml);

      // Bind events
      this.bindEvents(type, container, onSelectionChange, data);
    },

    // Render a single row
    renderRow: function(config) {
      const {
        person,
        index,
        type,
        existingData,
        canEditContact,
        reverseRoleMap,
      } = config;

      const existingPerson = this.findExistingPerson(person.name, existingData);
      let status, statusClass, statusText, updateTooltip = '';

      if (existingPerson) {
        const changes = this.getPersonChanges(existingPerson, person, reverseRoleMap);
        status = changes.length > 0 ? 'update' : 'exists';
        statusClass = status === 'update' ? 'status-update' : 'status-exists';

        if (status === 'update') {
          statusText = 'Update';
          updateTooltip = `Updates: ${changes.join(', ')}`;
        } else {
          statusText = 'Already in list';
        }
      } else if (person.matchedContact) {
        status = 'matched';
        statusClass = 'status-matched';
        statusText = `Matched: ${person.matchedContact.name}`;

        if (person.matchedContact && person.matchedContact.imdb_id) {
          statusText += ` (IMDB: ${person.matchedContact.imdb_id})`;
        }

        // Check what will be updated on the contact
        const contactUpdates = [];
        if (!person.matchedContact.imdb_id && person.imdbId) {
          contactUpdates.push('IMDB ID');
        }
        if (!person.matchedContact.avatar && person.image) {
          contactUpdates.push('Avatar');
        }
        if (contactUpdates.length > 0) {
          updateTooltip = `Contact updates: ${contactUpdates.join(', ')}`;
        }
      } else {
        status = 'new';
        statusClass = 'status-new';
        statusText = 'New contact';
      }

      // Avatar handling - use same classes as main table
      const avatarUrl = person.matched_avatar || person.image || null;
      let avatarHtml;

      if (avatarUrl && type === 'imdb') {
        // For IMDB imports, show actual avatar if available
        avatarHtml = `<div class="person-avatar"><img src="${avatarUrl}" alt="${person.name}" onerror="this.parentElement.className='person-avatar person-avatar-placeholder';this.parentElement.innerHTML='<i class=\\'fas fa-user\\'></i>';"></div>`;
      } else {
        // For CSV/paste imports, always use placeholder for consistency
        avatarHtml = '<div class="person-avatar person-avatar-placeholder"><i class="fas fa-user"></i></div>';
      }

      // Display multiple roles
      const rolesHtml = person.roles.map(role =>
        `<span class="role-tag role-${role}">${role}</span>`,
      ).join(' ');

      // Determine if we should link to an existing contact
      let contactId = null;
      if (existingPerson && existingPerson.id) {
        contactId = existingPerson.id;
      } else if (person.matchedContact) {
        contactId = person.matched_contact_id;
      }

      // Handle multiple matches
      let statusBadgeHtml;
      if (person.multipleMatches && person.allMatches && person.allMatches.length > 1) {
        // Create radio list for multiple matches
        statusBadgeHtml = `
          <div class="multiple-matches-container">
            <span class="status-badge status-multiple">Multiple matches found:</span>
            <div class="match-radio-list">
              ${person.allMatches.map((match, matchIndex) => {
    const isSelected = match.id === person.matched_contact_id;
    const editLink = canEditContact ?
      `<a href="/contact-person-edit?action=edit&id=${match.id}" target="_blank" class="edit-link" title="Edit contact">
                    <i class="fas fa-external-link-alt"></i>
                  </a>` : '';

    return `
                  <label class="match-radio-item">
                    <input type="radio" 
                           name="match-${type}-${index}" 
                           value="${match.id}"
                           data-person-index="${index}"
                           data-match-index="${matchIndex}"
                           class="match-radio"
                           ${isSelected ? 'checked' : ''}>
                    <span class="match-info">
                      ${match.name}
                      ${match.imdb_id ? `<span class="imdb-id">(IMDB: ${match.imdb_id})</span>` : ''}
                    </span>
                    ${editLink}
                  </label>
                `;
  }).join('')}
            </div>
          </div>
        `;
      } else {
        // Single match or no match - use existing logic
        statusBadgeHtml = (contactId && canEditContact && (status === 'matched' || status === 'update')) ?
          `<a href="/contact-person-edit?action=edit&id=${contactId}"
              class="status-badge-link"
              target="_blank">
            <span class="status-badge ${statusClass}" ${updateTooltip ? `title="${updateTooltip}"` : ''}>
              ${statusText}
              ${updateTooltip ? '<i class="fas fa-info-circle update-info"></i>' : ''}
            </span>
          </a>` :
          `<span class="status-badge ${statusClass}" ${updateTooltip ? `title="${updateTooltip}"` : ''}>
            ${statusText}
            ${updateTooltip ? '<i class="fas fa-info-circle update-info"></i>' : ''}
          </span>`;
      }

      return `
        <tr class="${statusClass}" data-index="${index}">
          <td><input type="checkbox" class="import-select-${type}" data-index="${index}" ${status !== 'exists' && status !== 'locked' ? 'checked' : ''} ${status === 'locked' ? 'disabled' : ''}></td>
          <td class="import-avatar-cell">${avatarHtml}</td>
          <td>${person.name}</td>
          <td>${person.character || '-'}</td>
          <td>${rolesHtml}</td>
          <td>${statusBadgeHtml}</td>
        </tr>
      `;
    },

    // Bind table events
    bindEvents: function(type, container, onSelectionChange, data) {
      // Select all checkbox
      $(`#select-all-${type}`).on('change', function() {
        $(`.import-select-${type}:not(:disabled)`).prop('checked', $(this).prop('checked'));
        if (onSelectionChange) {
          onSelectionChange();
        }
      });

      // Individual checkboxes
      $(container).on('change', `.import-select-${type}`, function() {
        if (onSelectionChange) {
          onSelectionChange();
        }
      });

      // Radio button change for multiple matches
      $(container).on('change', '.match-radio', function() {
        const personIndex = parseInt($(this).data('person-index'));
        const matchIndex = parseInt($(this).data('match-index'));
        const matchId = $(this).val();

        if (data && data[personIndex] && data[personIndex].allMatches) {
          const selectedMatch = data[personIndex].allMatches[matchIndex];
          if (selectedMatch) {
            // Update the person's matched contact
            data[personIndex].matchedContact = selectedMatch;
            data[personIndex].matched_contact_id = selectedMatch.id;
            data[personIndex].matched_avatar = selectedMatch.avatar;
            data[personIndex].matched_imdb_id = selectedMatch.imdb_id;
          }
        }
      });
    },

    // Find existing person by name
    findExistingPerson: function(name, existingData) {
      return existingData.find(p =>
        p.name && p.name.toLowerCase() === name.toLowerCase(),
      );
    },

    // Get changes between existing and new person
    getPersonChanges: function(existing, newPerson, reverseRoleMap) {
      const changes = [];

      // Get existing roles
      const existingRoles = this.getRolesForPerson(existing, reverseRoleMap);
      const rolesChanged = !this.arraysEqual(existingRoles.sort(), newPerson.roles.sort());

      if (rolesChanged) {
        changes.push('Roles');
      }

      // Check if character changed (for actors)
      if (newPerson.roles.includes('actor') &&
        (existing.contact_character_name || '') !== (newPerson.character || '')) {
        changes.push('Character name');
      }

      // Check if IMDB ID will be added
      if (!existing.c_imdb_id && newPerson.imdbId) {
        changes.push('IMDB ID');
      }

      // Check if avatar will be added
      if (!existing.c_avatar && newPerson.image) {
        changes.push('Avatar');
      }

      return changes;
    },

    // Get roles for person
    getRolesForPerson: function(person, reverseRoleMap) {
      const roleMap = {
        2: 'actor',
        3: 'director',
        7: 'writer',
        8: 'producer',
      };

      if (!person.contact_types || person.contact_types.length === 0) {
        return [];
      }

      return person.contact_types.map(typeId => roleMap[typeId]).filter(role => role);
    },

    // Check if arrays are equal
    arraysEqual: function(a, b) {
      return a.length === b.length && a.every((val, index) => val === b[index]);
    },

    // Get selected indices
    getSelectedIndices: function(type, container) {
      const indices = [];
      $(container).find(`.import-select-${type}:checked`).each(function() {
        indices.push(parseInt($(this).data('index')));
      });
      return indices;
    },
  };

  // Export to global namespace
  window.ImportPreviewTable = ImportPreviewTable;

})(jQuery);